<template>
    <!-- Modal -->
    <div class='modal fade' :id='id' tabindex='-1' role='dialog' :aria-labelledby='id'
         aria-hidden='true'
         ref="modalRef"
    >
        <div :class='`modal-dialog modal-${size} ${(centered ? "modal-dialog-centered" : "")}`' role='document'>
            <div class='modal-content'>
                <div class='modal-header' :class='{"p-0": removePaddingHeader}'>
                    <h5 class='modal-title'>
                        <slot name='title'></slot>
                    </h5>
                    <button v-if='showClose' type='button' aria-label='Close' class='btn-close'
                            @click='onClose'></button>
                </div>
                <div class='modal-body' :class='{"p-0": noPadding}' :style="`background: ${background}`">
                    <slot name='body'></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { watch, onMounted, ref, onUnmounted } from 'vue';

    const modalRef = ref(null);
    const emit = defineEmits(['onClose']);
    const bModal = ref(null);
    const props = defineProps({
        id: { type: String, required: true },
        size: { type: String, default: 'lg' },
        show: { type: Boolean, default: false },
        showClose: { type: Boolean, default: true },
        noPadding: { type: Boolean, default: false },
        centered: { type: Boolean, default: false },
        removePaddingHeader: { type: Boolean, default: false },
        background: { type: String, default: '' },
    });

    onMounted(() => {
        if (modalRef.value) {
            bModal.value = new bootstrap.Modal(modalRef.value, { backdrop: 'static' });
            checkView(props.show);
        }
    });

    watch(() => props.show, (newValue) => {
        checkView(newValue);
    });

    const onClose = () => {
        emit('onClose');
    };

    const checkView = (value) => {
        if (bModal.value && value) {
            bModal.value.show();
        }

        if (bModal.value && !value) {
            bModal.value.hide();
        }
    };

    const handleKeypress = (event) => {
        if (props.show) {
            if(event?.key && event.key === 'Escape') onClose();
            else if(event?.button && (event.button === 3 || event.button === 4)) onClose();
        }
    };
    
    onMounted(() => {
        document.addEventListener('keyup', handleKeypress); 
        document.addEventListener('mousedown', handleKeypress);
    });
    
    onUnmounted(() => {
        document.removeEventListener('keyup', handleKeypress);
        document.removeEventListener('mousedown', handleKeypress);
    });
    
    defineExpose({ modalRef });
</script>
